import { render } from "./crm-permission.vue?vue&type=template&id=3d6a2515"
import script from "./crm-permission.vue?vue&type=script&lang=js"
export * from "./crm-permission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__